module.exports = __webpack_public_path__ + "05_mole.1a5180d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/05_mole.png
// module id = hE6r
// module chunks = 0